module.exports = __webpack_public_path__ + "img/cars.9c89f824.gif";